import Vue from "vue";

export default {
  methods: {
    displayAlert(title = '', icon = "success", toast, showConfirmButton = false, timer = 1500, position = "top-end") {
      Vue.swal({
        position: position,
        icon: icon,
        title: title,
        showConfirmButton: showConfirmButton,
        timer: timer,
        toast: toast,
      });
    },
    successToast(title = '', showConfirmButton = false, timer = 2000, position = "top-end") {
      this.displayAlert(title, "success", true, showConfirmButton, timer, position);
    },
    errorToast(title = '', showConfirmButton = false, timer = 1000, position = "top-end") {
      this.displayAlert(title, "error", true, showConfirmButton, timer, position);
    },
    infoToast(title = '', showConfirmButton = false, timer = 1000, position = "top-end") {
      this.displayAlert(title, "info", true, showConfirmButton, timer, position);
    },
    warningToast(title = '', showConfirmButton = false, timer = 2000, position = "top-end") {
      this.displayAlert(title, "warning", true, showConfirmButton, timer, position);
    },
    confirm(
      title = '',
      text = '',
      html = '',
      icon = "warning",
      confirmButtonText = "削除",
      cancelButtonText = "戻る",
      showCancelButton = true,
      cancelButtonColor = "#d33",
      width = "32em"
    ) {
      let confirmButtonColor = "#3085d6";
      if (confirmButtonText === this.$lang.button.delete) {
        confirmButtonColor = "#d33";
        cancelButtonColor = "#3085d6";
      } else if (confirmButtonText === this.$lang.button.ok) {
        confirmButtonText = '<i class="fas fa-check"></i> ' + confirmButtonText;
      }

      if (cancelButtonText === this.$lang.button.cancel) {
        cancelButtonText = '<i class="fas fa-times"></i> ' + cancelButtonText;
      }

      return Vue.swal.fire({
        title: title,
        text: text,
        html: html,
        icon: icon,
        width: width,
        showCancelButton: showCancelButton,
        confirmButtonColor: confirmButtonColor,
        cancelButtonColor: cancelButtonColor,
        confirmButtonText: confirmButtonText,
        cancelButtonText: cancelButtonText,
      })
    }
  },
};
